import { render, staticRenderFns } from "./empathize.vue?vue&type=template&id=785851a8&"
import script from "./empathize.vue?vue&type=script&lang=ts&"
export * from "./empathize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports